import React, { useEffect } from "react";

function DisabledFeatureModal({ onClose }) {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div style={styles.overlay} onClick={handleOverlayClick}>
      <div style={styles.modal}>
        <div style={styles.content}>
          <div style={styles.iconBox}>
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <circle cx="24" cy="24" r="20" stroke="#FF6258" strokeWidth="2" fill="none"/>
              <path d="M24 14V26" stroke="#FF6258" strokeWidth="2" strokeLinecap="round"/>
              <circle cx="24" cy="32" r="1.5" fill="#FF6258"/>
            </svg>
          </div>
          <h3 className="font-s-head3-bold" style={styles.title}>
            현재 지원하지 않는 기능입니다
          </h3>
          <p className="font-body2-regular" style={styles.message}>
            해당 기능은 현재 사용할 수 없습니다.<br/>
            문의사항이 있으시면 관리자에게 연락해주세요.
          </p>
          <button
            className="font-body3-bold"
            style={styles.button}
            onClick={onClose}
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "16px",
    padding: "40px",
    maxWidth: "400px",
    width: "90%",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  iconBox: {
    marginBottom: "24px",
  },
  title: {
    color: "var(--grayscale_90)",
    marginBottom: "16px",
  },
  message: {
    color: "var(--grayscale_70)",
    marginBottom: "32px",
    lineHeight: "1.6",
  },
  button: {
    backgroundColor: "var(--primary-crimson_60)",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "12px 32px",
    cursor: "pointer",
    minWidth: "120px",
  },
};

export default DisabledFeatureModal;
